import React, { useEffect } from 'react';
import { HeaderContainer, TabItem, TabList, HeaderOptions, TabIcon, PopOutIcon } from './styles';
import { ButtonsContainer, RectangleButton } from 'components/Button/RectangleButton';
import DropdownButton from 'components/Dropdown/DropdownButton';
import { buttonIds } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import { useFreecodeContextRun } from 'hooks/useContext';

const FreecodePlayerHeader = React.forwardRef(
  (
    {
      items,
      active,
      setActive,
      humanInput,
      interacting,
      startHumanInput,
      stopHumanInput,
      interactSessionState,
      handleInteractAction,
      isPopOut,
      setIsPopOut,
      allLoaded,
    },
    ref
  ) => {
    let options = [
      { label: 'Restart Interact', action: 'restart' },
      { label: 'Reset', action: 'reset' },
    ];

    const { isRunning } = useFreecodeContextRun() ?? {};

    useEffect(() => {
      if (isRunning && interacting) stopHumanInput();
    }, [interacting, isRunning, stopHumanInput]);

    const renderHumanInputActions = () => {
      return interactSessionState ? (
        <DropdownButton
          id={buttonIds.interactDropdown}
          leftDrop={true}
          title="Handle the interact status"
          value={
            interacting ? { label: 'Stop Interact', action: 'stop' } : { label: 'Resume Interact', action: 'start' }
          }
          options={options}
          handleClick={handleInteractAction}
        />
      ) : (
        <ButtonsContainer padding={'0'}>
          {interacting ? (
            <RectangleButton small marginRight onClick={() => stopHumanInput()}>
              Stop Interact
            </RectangleButton>
          ) : (
            <RectangleButton small marginRight disabled={!allLoaded} onClick={() => startHumanInput()}>
              Interact
            </RectangleButton>
          )}
        </ButtonsContainer>
      );
    };

    return (
      <HeaderContainer ref={ref}>
        <TabList>
          {items.map((item, index) => (
            <TabItem id={item.tabId} key={index} active={index === active} onClick={() => setActive(index)}>
              {item.icon && <TabIcon active={index === active} icon={item.icon} />}
              {item.label}
            </TabItem>
          ))}
        </TabList>
        <HeaderOptions>
          {humanInput && renderHumanInputActions()}
          <PopOutIcon
            icon={isPopOut ? 'fa fa-compress' : 'fa fa-expand'}
            onClick={() => setIsPopOut(!isPopOut)}
            title={'Toggle player overlay'}
          />
        </HeaderOptions>
      </HeaderContainer>
    );
  }
);

export default FreecodePlayerHeader;
